/** @format */

import { AvailabilityByLocation } from './availability-by-location.interface';

// https://github.com/dsg-tech/eat-availability-api-cloud/blob/master/src/main/java/com/dcsg/availability/model/response/AvailabilityByLocationWithCurbsideResponseWrapper.java
export interface AvailabilityByLocationResponse {
  data: AvailabilityByLocation;
  status: 'OK' | 'NOT_OK';
}
